import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchLastStatus} from '../../../../creators/home.lastStatus';


import StatusCard from './StatusCard';
import Carousel from "../../../components/Carousel";


const Status = (props) => {
    let {status = [], start = 0} = props;
    let end = start + 3;
    for (let i = 0; i <= 3; i++) {
        let sliced = status.slice(start, end);
        start = start + 4;
        end = start + 3;
        return (
            <div className="col">
                <div className="status-wrapper">
                    {sliced.map((status) => (
                        <StatusCard
                            key={status._id}
                            {...status}
                        />
                    ))}
                </div>
            </div>
        )
    }
}


class StatusHome extends React.Component {

    constructor(props){
        super(props);
        this.props.fetchLastStatus();
    }

    clearDraft(contentRaw = {}){
        let isContent = false;
        contentRaw.blocks = contentRaw.blocks.map((item)=>{
            item.text = item.text.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
            if(item.text !== "attachment" && item.text !== "📷" && item.text !== ""){
                isContent = true;
            }
            item.text = item.text.trim();
            return item;
        });

        return {contentRaw, isContent};
    }

    clearStatus(){
        let status = Array.isArray(this.props.status) ? this.props.status : [];
        let newStatus = [];
        status.forEach(item=>{
            let clearDraft = this.clearDraft(item.contentRaw);
            if(clearDraft.isContent){
                item.contentRaw = clearDraft.contentRaw;
                newStatus.push(item);
            }
        });
        return newStatus.slice(0,96);
    }

    render() {
        let status = []
        if(this.props.statusInitialized){
            status = this.clearStatus();
        }
        return (
            <div className="container">
                <div className="col left">
                    <div className="head-title">
                        <div className="section-title">Les derniers statuts</div>
                        {/*<Button className={"margin-bottom-60"}*/}
                        {/*corner={"btn-rounded"}*/}
                        {/*to={"/"}*/}
                        {/*size={"big"}*/}
                        {/*btnStyle={"primary"}*/}
                        {/*content={"VOIR TOUS LES STATUTS"}/>*/}
                    </div>
                    <Carousel>
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={status} start={0} />
                                    <Status status={status} start={4} />
                                    <Status status={status} start={8} />
                                </div>
                            </div>
                        </div>
                        {status.length > 12 ? (
                            <div className="pane">
                                <div className="row">
                                    <div className="left-col-wrapper">
                                        <Status status={status} start={12} />
                                        <Status status={status} start={16} />
                                        <Status status={status} start={20} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {status.length > 24 ? (
                            <div className="pane">
                                <div className="row">
                                    <div className="left-col-wrapper">
                                        <Status status={status} start={24} />
                                        <Status status={status} start={28} />
                                        <Status status={status} start={30} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {status.length > 34 ? (
                            <div className="pane">
                                <div className="row">
                                    <div className="left-col-wrapper">
                                        <Status status={status} start={34} />
                                        <Status status={status} start={38} />
                                        <Status status={status} start={42} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {status.length > 46 ? (
                            <div className="pane">
                                <div className="row">
                                    <div className="left-col-wrapper">
                                        <Status status={status} start={46} />
                                        <Status status={status} start={50} />
                                        <Status status={status} start={54} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {status.length > 58 ? (
                            <div className="pane">
                                <div className="row">
                                    <div className="left-col-wrapper">
                                        <Status status={status} start={58} />
                                        <Status status={status} start={62} />
                                        <Status status={status} start={66} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {status.length > 70 ? (
                            <div className="pane">
                                <div className="row">
                                    <div className="left-col-wrapper">
                                        <Status status={status} start={70} />
                                        <Status status={status} start={74} />
                                        <Status status={status} start={78} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {status.length > 82 ? (
                            <div className="pane">
                                <div className="row">
                                    <div className="left-col-wrapper">
                                        <Status status={status} start={82} />
                                        <Status status={status} start={86} />
                                        <Status status={status} start={90} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </Carousel>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.homeLastStatus.data,
        statusLoading: state.homeLastStatus.loading,
        statusInitialized: state.homeLastStatus.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchLastStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StatusHome);
